import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import classNames from 'classnames';
import classes from './InvitationBanner.module.scss';
import Button from '@shared/Button/Button';
import { useWindowSize } from '@hooks/useWindowSize';
import { trialDays } from '@const';
import { useSelector } from 'react-redux';
import { newChildPhoneSelector, paymentStatusesSelector, subscriptionPriceSelector } from '@models/subscription/selectors';
import { getMaskedPhone } from '@utils/masks';
import ChildPhoneCard from '@shared/ChildPhoneCard/ChildPhoneCard';
import { themeSelector } from '@store/models/user/selectors';
import { useEffect } from 'react';
import { triggerMetricsEvent } from '@metrics';
import { isMetricsLoadedSelector } from '@models/metrics/selectors';
import { getSubscribeDescText } from '@configs/subscription';
import { TariffPlanEnum } from '@store/models/subscription/types';
const invitationImg = '/images/banner/family-invitation-600.svg';
const invitationImgMobile = '/images/banner/family-invitation.svg';
const InvitationBanner = ({ className }) => {
    const { isDesktopExtraLg, isDesktopLg, isMobileSm } = useWindowSize();
    const invitationPhone = useSelector(newChildPhoneSelector);
    const theme = useSelector(themeSelector);
    const { isFree } = useSelector(paymentStatusesSelector);
    const childPhone = getMaskedPhone(invitationPhone);
    const isDark = theme === 'dark';
    const isMetricsLoaded = useSelector(isMetricsLoadedSelector);
    useEffect(() => {
        if (isMetricsLoaded) {
            triggerMetricsEvent({ element: 'inviteFromChildBanner' });
        }
    }, [isMetricsLoaded]);
    const blockClasses = classNames(classes.invitation, className);
    const tariffClasses = classNames(classes.tariff, 'text-secondary');
    const subscriptionPrice = useSelector(subscriptionPriceSelector);
    const buttonSize = isDesktopLg || isDesktopExtraLg ? 'extra-lg' : 'md';
    const cancelButtonVariant = isMobileSm && !isDark ? 'transparent' : 'alwaysWhite';
    const imgSrc = isMobileSm ? invitationImgMobile : invitationImg;
    const handleAcceptClick = () => {
        triggerMetricsEvent({ element: 'inviteAcceptButton' });
    };
    const handleCancelClick = () => {
        triggerMetricsEvent({ element: 'inviteRejectButton' });
    };
    return (_jsxs("section", { className: blockClasses, children: [_jsx("img", { className: classes.image, alt: "Happy family", src: imgSrc }), _jsxs("div", { className: classes.content, children: [_jsxs("h2", { className: classes.title, children: ["\u0412\u0430\u0441 \u043F\u0440\u0438\u0433\u043B\u0430\u0441\u0438\u043B \u0420\u0435\u0431\u0451\u043D\u043E\u043A ", _jsx("br", {}), " \u0432 \u043F\u043E\u0434\u043F\u0438\u0441\u043A\u0443 \u041C\u0422\u0421 Junior"] }), _jsx(ChildPhoneCard, { phone: childPhone, title: "\u041D\u043E\u043C\u0435\u0440 \u0420\u0435\u0431\u0451\u043D\u043A\u0430", className: classes.phoneCard }), _jsx("p", { className: tariffClasses, children: getSubscribeDescText({ isTrialPeriod: isFree, price: subscriptionPrice, trialDays, plan: TariffPlanEnum.Month }) }), _jsxs("div", { className: classes.buttons, children: [_jsx(Button, { className: classNames(classes.button, classes.acceptButton), size: buttonSize, text: "\u041F\u0440\u0438\u043D\u044F\u0442\u044C \u043F\u0440\u0438\u0433\u043B\u0430\u0448\u0435\u043D\u0438\u0435", full: isMobileSm, variant: "primary", onClick: handleAcceptClick }), _jsx(Button, { className: classNames(classes.button, classes.cancelButton), size: buttonSize, text: "\u041E\u0442\u043A\u043B\u043E\u043D\u0438\u0442\u044C", full: isMobileSm, variant: cancelButtonVariant, onClick: handleCancelClick })] })] })] }));
};
export default InvitationBanner;
